import { getConfig, getWhiteLabelConfig, setConfig } from '@taleemabad/db';
import { TBConfig } from 'libs/db/src/types/user';
import { PropsWithChildren, createContext, useEffect, useState } from 'react';
import { updateTheme } from '../utils/utils';
const config: TBConfig = {
  app: 'niete',
  appLogoPath: 'niete-logo.svg',
  appLogoWidthNavbar: '240',
  appLogoWidthLanding: '550',
};
export const ConfigContext = createContext<TBConfig>(config);

export const ConfigProvider = ({ children }: PropsWithChildren) => {
  const data = getConfig();
  const [configuration, setConfiguration] = useState<TBConfig>(
    data ? data : config,
  );
  useEffect(() => {
    const fetchData = async () => {
      if (!data) {
        try {
          const res = await getWhiteLabelConfig();
          setConfiguration(res.configuration);
          setConfig(res.configuration);
          updateTheme(configuration.app);
        } catch (error) {}
      } else {
        updateTheme(configuration.app);
      }
    };

    fetchData();
  }, []);
  return (
    <ConfigContext.Provider value={configuration}>
      {children}
    </ConfigContext.Provider>
  );
};
